<template>
  <div class="expand js-filterable">
    <slot v-bind="self" />
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ExpandComponent',

  props: { accordion: Boolean },

  data () {
    return {
      expanded: {}
    }
  },

  provide () {
    return {
      expandedItems: computed(() => this.expanded)
    }
  },

  computed: {
    self () {
      return { instance: this }
    }
  },

  methods: {
    isExpanded (index) {
      return !!this.expanded?.[index]
    },
    toggleExpand (index) {
      const nextState = !this.isExpanded(index)

      if (this.accordion) {
        this.expanded = {}
      }

      this.expanded[index] = nextState
    }
  }
}
</script>
